export default {
      id: "reefer-dor-close-usage",
      viewBox: "0 0 35 30",
      url: __webpack_public_path__ + "img/icons.svg#reefer-dor-close",
      toString: function () {
        return this.url;
      }
    }